import { render } from "./ShareButtons.vue?vue&type=template&id=7148dc32&scoped=true"
import script from "./ShareButtons.vue?vue&type=script&lang=js"
export * from "./ShareButtons.vue?vue&type=script&lang=js"

import "./ShareButtons.vue?vue&type=style&index=0&id=7148dc32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7148dc32"]])

export default __exports__